import React from 'react';
import {
    AccountDetailsGridContainer,
    AccountDetailsGrid,
    AccountDetailsFont,
    AccountDetailsTitle,
    RadioAlign,
} from './AccountDetails.styled';
import Select from 'src/common/refactoredComponents/select/Select';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import Notes from 'src/common/components/notes';
import { sizes } from 'src/styles/Media.styled';
import { isIpad, isMobileDevice, logErrorToConsole } from 'src/utils/util';
import {
    setUnsavedChange,
    setCommonCancel,
} from 'src/pages/more/redux/actions/index.js';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
const winWidth = window.innerWidth;

const AccountDetailEdit = ({
    // selectedOption,
    // setSelectedOption,
    carrierPickup,
    setCarrierPickup,
    templateNote,
    setTemplateNote,
    carrierOptions,
    selectedCarrier,
    handleChange,
    setTemplateNotesPopup,
}) => {
    const dispatch = useDispatch();
    const iPad = isIpad();
    const isMobile = isMobileDevice();
    const { t } = useTranslation();
    // useEffectWithErrorLogging(() => {
    //     // dispatch(
    //     //     setSelectedOption({
    //     //         label:
    //     //             String(accountDet && accountDet.carrierLabelDisplay) ===
    //     //             'FedEx'
    //     //                 ? 'FedEx'
    //     //                 : String(
    //     //                       accountDet && accountDet.carrierLabelDisplay
    //     //                   ) === 'UPS'
    //     //                 ? 'UPS'
    //     //                 : '',
    //     //         value:
    //     //             String(accountDet && accountDet.carrierLabelDisplay) ===
    //     //             'FedEx'
    //     //                 ? '1US'
    //     //                 : String(
    //     //                       accountDet && accountDet.carrierLabelDisplay
    //     //                   ) === 'UPS'
    //     //                 ? '2US'
    //     //                 : '',
    //     //     })
    //     // );
    // }, []);

    //const [templateNotesPopup, setTemplateNotesPopup] = useState(false);
    // const handleChange = (selectValue) => {
    //     debugger;
    //     const clickeddOption = options.filter((v) => v.value === selectValue);

    //     dispatch(setUnsavedChange(true));
    //     setSelectedCarrier({
    //         label: clickeddOption[0].label,
    //         value: clickeddOption[0].value,
    //     });

    // };

    const handleNote = (note) => {
        dispatch(setCommonCancel(false));
        dispatch(setUnsavedChange(true));
        const lengthOfNote = note.length;
        if (lengthOfNote <= 4000) {
            setTemplateNote(note);
        } else {
            const sliceLastIdx = 4000 - lengthOfNote;
            setTemplateNote(note.slice(0, sliceLastIdx));
            setTemplateNotesPopup(true);
        }
    };
    const CarrierPickupChange = (type) => {
        dispatch(setUnsavedChange(true));
        setCarrierPickup(type);
    };

    const closekeyBoard = () => {
        document.activeElement.blur();
    };

    const handlePopupOnKeyPress = () => {
        if (templateNote.length >= 4000) {
            setTemplateNotesPopup(true);
            closekeyBoard();
        }
    };

    return (
        <AccountDetailsGridContainer
            container
            justifyContent={'space-between'}
            direction="row"
            style={{
                marginBottom: iPad ? '168px' : isMobile ? '0' : '70px',
                paddingBottom: iPad ? '5px' : '',
            }}
        >
            <AccountDetailsGrid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                mobile={12}
                style={{ marginTop: '0' }}
            >
                <AccountDetailsTitle
                    deskmarginTop={'0px'}
                    deskmarginBottom={'5px'}
                    isDemi
                >
                    {t('accounts.accountDetailCard.carrier')}
                </AccountDetailsTitle>
                <AccountDetailsFont isRegular>
                    <Select
                        id="more-accountDetails-accounts-selectCarriers"
                        placeholder={t(
                            'accounts.accountDetailCard.selectCarriers'
                        )}
                        options={carrierOptions}
                        value={selectedCarrier && selectedCarrier.value}
                        onChange={handleChange}
                        width={
                            winWidth <= sizes.mobileDevice ? '100%' : 
                                (Math.max(window.innerWidth) >= 670 && Math.max(window.innerWidth) <= 820) &&
                                (Math.min(window.innerHeight) >= 1060 && Math.min(window.innerHeight) <= 1110)
                                ? '300px'
                                : '350px'
                        }
                    />
                </AccountDetailsFont>
                <AccountDetailsTitle isDemi style={{ marginTop: '21px' }}>
                    {t('accounts.accountDetailCard.carrierPickupNotifications')}
                </AccountDetailsTitle>

                {/* <AccountDetailsFont isRegular> */}
                <RadioAlign isRegular>
                    <RadioButton
                        label={t('equity.surgery.notifications.yes')}
                        id={'surgeryNotification-yes'}
                        fontFamilyStyle="AvenirNextWorld Regular"
                        value={carrierPickup}
                        isChecked={carrierPickup == 'Yes' ? true : false}
                        handleChange={() => {
                        try {
                            CarrierPickupChange('Yes');
                             } catch (error) {
                                logErrorToConsole(error);
                             }
                        }}
                        // name="carrierPickup"
                    />

                    <RadioButton
                        label={t('equity.surgery.notifications.no')}
                        id={'surgeryNotification-no'}
                        fontFamilyStyle="AvenirNextWorld Regular"
                        value={carrierPickup}
                        isChecked={carrierPickup == 'No' ? true : false}
                        handleChange={() => {
                            try {
                                CarrierPickupChange('No');
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        name="carrierPickup"
                    />
                </RadioAlign>
                {/* </AccountDetailsFont> */}
            </AccountDetailsGrid>
            <AccountDetailsGrid
                className="carrier-notes-container"
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                mobile={12}
                style={{
                    padding: isMobile ? '10px 1rem 1rem 1rem' : '1rem',
                    marginTop: '0',
                }}
            >
                {/* <AccountDetailsTitle isDemi>Carrier Notes</AccountDetailsTitle> */}
                {/* <CarrierInput />
                <AccountDetailsTextarea>
                    {' '}
                    Add a new note(max 4000 character)
                </AccountDetailsTextarea> */}
                <Notes
                    id="pricingNoteDivId"
                    // note={reasontext}
                    // updateNotes={updateReason}
                    // maxLength={textAreaCharLimit}

                    //width={'313px'}

                    title={t('accounts.accountDetailCard.carrierNotes')}
                    margin={
                        window.innerWidth <= sizes.mobileDevice
                            ? '0px 0 0 0'
                            : '0px 0px 0 0'
                    }
                    fontSize={'14px'}
                    note={templateNote}
                    updateNotes={handleNote}
                    // helperText={`${
                    //     4000 - templateNote?.length < 0
                    //         ? 0
                    //         : 4000 - templateNote?.length
                    // } characters remaining`}
                    helperText={`${t('accounts.accountDetailCard.addnote')} ${
                        templateNote !== undefined
                            ? 4000 -
                              (templateNote?.length < 0
                                  ? 0
                                  : 4000 - templateNote?.length)
                            : 4000
                    } ${t('accounts.accountDetailCard.characters')}`}
                    boxShadow={'none'}
                    contentBodyMargin={'10px 0 0 0'}
                    cardHeaderMargin={'0px 0 0 0'}
                    cardFooterMargin={'10px 0 0 0'}
                    //ipadWidth={'33%'}

                    //mediumWidth={'270px'}

                    // maxLength={textAreaCharLimit}
                    autoResize={false}
                    isScrollBar={true}
                    isTextAreaResize={false}
                    textAreaBorderRadius={'6px'}
                    placeholderFont={'11px'}
                    placeholder={t('accounts.accountDetailCard.carrierNote')}
                    placeholderFontFamily="AvenirNextWorld Regular"
                    // padding ={' padding: 10px'}
                    // placeholderHeight={'50px'}
                    row={2}
                    onKeyPress={handlePopupOnKeyPress}
                    height={isMobile ? 'auto' : 'auto'}
                />
            </AccountDetailsGrid>
            {/* {templateNotesPopup ? (
                <AddedMoreThanTenItems
                    title="Form doesn't allow characters past 4000"
                    onClose={() => {
                        setTemplateNotesPopup(false);
                    }}
                    opacity={'1'}
                    zIndex={999999999}
                    background={'#000000cc 0% 0% no-repeat padding-box'}
                />
            ) : null} */}
        </AccountDetailsGridContainer>
    );
};
export default AccountDetailEdit;
